import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import MangeDashboard from "./ManageDashboard";
import { toast } from "react-toastify";
import { useNavigate, useSearchParams } from "react-router-dom";
import Factor from "./Factor";
import ResultOrder from "./ResultOrder";
import AfterLoginNav from "../AfterLoginNav";
import { getCurrentGoldPrice } from "../../services/gold-price";
import { getSystemContents } from "../../services/statistics";
import { getSystemParameters } from "../../services/cms";
import { isDevelopmentMode } from "../../services/base";
import { submitTradeRequest } from "../../services/trade";
import ScrollOnMainPage from "../ScrollOnMainPage";
import { getCommoditiesList } from "../../services/commodities";
import Products from "../../components/Products";
import { toPersianNum } from "../../utils/persianNumbers";

export default function TradeMarket() {
  const navigate = useNavigate();
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [amount, setamount] = useState(0);
  const [active, setActive] = useState("buy");
  const [gramPriceSell, setGramPriceSell] = useState(100000);
  const [soatPriceSell, setSoatPriceSell] = useState(20000);
  const [gramPriceBuy, setGramPriceBuy] = useState(100000);
  const [soatPriceBuy, setSoatPriceBuy] = useState(20000);
  const [gram, setGram] = useState(0);
  const [soat, setSoat] = useState(0);
  const [landing, setLanding] = useState([]);
  const [resultModal, setResultModal] = useState(false);
  const [FactorOpen, setFactorOpen] = useState(false);
  const [FactorData, setFactorData] = useState();
  const [karmozdBuy, setKarmozdBuy] = useState();
  const [karmozdSell, setKarmozdSell] = useState();
  const [karmozd, setKarmozd] = useState(0);
  const [render, setRender] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [requestKey, setRequestKey] = useState("");
  const [commodities, setCommodities] = useState([]);
  const [selectedCommodity, setSelectedCommodity] = useState({
    id: "",
    ui_data: { unit_name: null },
  });
  const [searchParams] = useSearchParams();
  function mynormalNum(num) {
    try {
      num = num.replace(/,\s?/g, "");
      return num;
    } catch (e) {
      return "";
    }
  }

  function handleFactorResult(pay) {
    submitTradeRequest(
      !isNaN(amount) && amount > 0 ? (active === "buy" ? pay : -1 * pay) : null,
      isNaN(amount) ? gram + soat / 1000 : null,
      selectedCommodity.id,
      requestKey
    )
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.data) {
            setRender(render + 1);
            setFactorData({});
            setFactorOpen(false);
            toast.success("درخواست شما با موقیت ثبت شد");
          }
        } else {
          if (active === "sell") {
            if (
              res.data.detail === "بدون تکمیل اطلاعات مجاز به خرید بیشتر نیستید"
            ) {
              toast.error("بدون تکمیل اطلاعات مجاز به فروش نیستید");
            } else {
              toast.error(res.data.detail);
            }
          } else {
            toast.error(res.data.detail);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (active === "sell") {
          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors[0] &&
            error.response.data.errors[0].detail ===
              "بدون تکمیل اطلاعات مجاز به خرید بیشتر نیستید"
          ) {
            toast.error("بدون تکمیل اطلاعات مجاز به فروش نیستید");
          } else {
          }
        } else {
        }
      });
  }
  function handleCalc(event) {
    let p = event.target.value;
    let name = event.target.name;
    var res = 0;

    if (p < 0) {
      return;
    }

    if (!p) {
      p = 0;
    }

    if (name == "gram") {
      let value = parseInt(p);
      if (active == "buy") {
        res = (Number(value) + Number(soat / 1000)) * Number(gramPriceBuy);
      } else {
        res = (Number(value) + Number(soat / 1000)) * Number(gramPriceSell);
      }
      setGram(value);
      setamount(res);
      if (res) {
        document.getElementById("price_amount").value = new Intl.NumberFormat(
          "en",
          { maximumFractionDigits: 0 }
        ).format(res);
      } else {
        document.getElementById("price_amount").value = "";
      }
    }

    if (name == "soat") {
      let value = parseInt(p);

      if (value > 999) {
        return;
      }
      if (active == "buy") {
        res = Number(gram * gramPriceBuy) + Number(value * soatPriceBuy);
      } else {
        res = Number(gram * gramPriceSell) + Number(value * soatPriceSell);
      }

      setSoat(value);
      setamount(res);
      if (res) {
        document.getElementById("price_amount").value = new Intl.NumberFormat(
          "en",
          { maximumFractionDigits: 0 }
        ).format(res);
      } else {
        document.getElementById("price_amount").value = "";
      }
    }

    if (name == "price_amount") {
      p = mynormalNum(p);
      setamount(p);

      let value = parseInt(p);

      let rem = 0;

      if (active == "buy") {
        res = value / Number(gramPriceBuy);
        rem = value % Number(gramPriceBuy);
      } else {
        res = value / Number(gramPriceSell);
        rem = value % Number(gramPriceSell);
      }

      if (rem != 0) {
        if (active == "buy") {
          rem = rem / soatPriceBuy;
        } else {
          rem = rem / soatPriceSell;
        }
        if (rem >= 1) {
          rem = parseInt(rem);
          setSoat(rem);
        } else {
          setSoat(0);
        }
      } else {
        setSoat(0);
      }

      if (res >= 1) {
        res = parseInt(res);

        setGram(res);
      } else {
        setGram(0);
      }
    }
  }

  useEffect(() => {
    setSoat("");
    setGram("");
    setamount("");
    if (!isNaN(selectedCommodity.id) && selectedCommodity.id > 0) {
      getCurrentGoldPrice(selectedCommodity.id).then((res) => {
        if (res.status == 200) {
          let data = res?.data?.data;

          if (data) {
            setGramPriceBuy(data.buy_price.gram);
            setGramPriceSell(data.sell_price.gram);
            setSoatPriceBuy(data.buy_price.soot);
            setSoatPriceSell(data.sell_price.soot);
            try {
              document.getElementById("soat").value = "";
            } catch (e) {}
            document.getElementById("gram").value = "";
            document.getElementById("price_amount").value = "";
          }
        }
      });
      getSystemParameters(selectedCommodity.id).then((res) => {
        if (res.status == 200) {
          let data = res?.data?.results;
          if (!isDevelopmentMode()) {
            if (data) {
              setKarmozdBuy(data.wage_market_buy);
              setKarmozdSell(data.wage_market_sell);
            }
          } else {
            if (data) {
              data.map((item) => {
                if (item.key === "wage_tsh_buy") {
                  setKarmozdBuy(item.value);
                }
              });
              data.map((item) => {
                if (item.key === "wage_tsh_sell") {
                  setKarmozdSell(item.value);
                }
              });
            }
          }
        }
      });
    }
  }, [selectedCommodity.id]);

  useEffect(() => {
    function fetchData() {
      getCommoditiesList().then((res) => {
        if (res.status === 200) {
          const data = res?.data?.results;
          const defaultCommodity = searchParams.get("commodity_id");
          if (defaultCommodity) {
            setSelectedCommodity(data.find((el) => el.id == defaultCommodity));
          } else {
            console.log("data is", data[0]);
            setSelectedCommodity(data[0]);
          }
          if (data) {
            setCommodities(data);
          }
        }
      });
      getSystemContents().then((res) => {
        if (res.status == 200) {
          let data = res.data?.results;
          if (data) {
            setLanding(data);
          }
        }
      });
    }
    fetchData();
  }, []);

  function separateNum(event) {
    let value = event.target.value;
    var nStr = value + "";
    nStr = nStr.replace(/\,/g, "");
    let x = nStr.split(".");
    let x1 = x[0];
    let x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    if (event !== undefined) {
      event.target.value = x1 + x2;
      ex_normalNum(event.target.value);
    } else {
      return x1 + x2;
    }
  }

  function ex_normalNum(num) {
    num = num.replace(/,\s?/g, "");
    setamount(num);
  }

  function fetchFactor(data) {
    setFactorData(data);
    setFactorOpen(true);
  }

  function handleSubmit() {
    if (!gram && !soat && !amount) {
      toast.error("لطفا مقادیر را به درستی وارد نمایید");
    }

    setIsLoading(true);
    submitTradeRequest(
      null,
      active === "buy"
        ? commodities
            ?.find((el) => el.id == selectedCommodity.id)
            ?.name.indexOf("طلا") >= 0
          ? gram + soat / 1000
          : gram
        : commodities
            ?.find((el) => el.id == selectedCommodity.id)
            ?.name.indexOf("طلا") >= 0
        ? -1 * (gram + soat / 1000)
        : -1 * gram,
      selectedCommodity.id
    )
      .then((res) => {
        setIsLoading(false);
        if (res.status === 200 || res.status === 201) {
          if (res.data && res.data.data) {
            fetchFactor(res.data.data);
            setRequestKey(res.data.data.request_key);
          }
        } else {
          if (active === "sell") {
            if (
              res.data.detail === "بدون تکمیل اطلاعات مجاز به خرید بیشتر نیستید"
            ) {
              toast.error("بدون تکمیل اطلاعات مجاز به فروش نیستید");
            } else {
              toast.error(res.data.detail);
            }
          } else {
            toast.error(res.data.detail);
          }
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  return (
    <>
      <>
        {FactorData ? (
          <>
            <Factor
              modalIsOpen={FactorOpen}
              Openchanger={setFactorOpen}
              commodity={selectedCommodity.id}
              commodityInfo={commodities.filter(
                (el) => el.id == selectedCommodity.id
              )}
              data={FactorData}
              gram={gram}
              soat={soat}
              karmozd={karmozd}
              typeOrder={active}
              resultChanger={handleFactorResult}
            />
          </>
        ) : (
          <></>
        )}

        <ResultOrder
          modalIsOpen={resultModal}
          Openchanger={setResultModal}
          data={FactorData}
          commodity={selectedCommodity.id}
          commodityInfo={commodities.filter(
            (el) => el.id == selectedCommodity.id
          )}
          gram={gram}
          soat={soat}
          karmozd={karmozd}
          typeOrder={active}
        />

        <MangeDashboard>
          <>
            <AfterLoginNav title={"معامله"} hasBack={() => navigate(-1)} />
            <div className="container margin-for-trade-container">
              <div className="row justify-content-center align-items-center">
                <div className="col-xl-8 col-md-8">
                  <div className="top-message-trade-wrapper">
                    <div className="top-message-trade">
                      {landing.map((item) => {
                        return item.key === "footer_content" ? (
                          <>{item.value}</>
                        ) : null;
                      })}
                    </div>
                  </div>
                  {isTabletOrMobile && (
                    <div className="select-commodity-limit-order">
                      <select
                        className="form-input-gray-custom gray-text-with-padding"
                        value={selectedCommodity.id}
                        onChange={(e) => {
                          const selected = commodities.find(
                            (el) => el.id == e.target.value
                          );
                          setSelectedCommodity(selected);
                        }}
                      >
                        {commodities.map((commodity) => (
                          <option value={commodity.id}>
                            {toPersianNum(commodity.name)}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                  <div className="trade-tabs-container">
                    <div className="trade-tab-wrapper">
                      <div className="trade-tab">
                        <div
                          className={
                            active == "buy"
                              ? "tab-item tab-item-active w-100"
                              : "tab-item w-100"
                          }
                          onClick={() => {
                            document.getElementById("price_amount").value = "";
                            setGram("");
                            setSoat("");
                            setActive("buy");
                          }}
                        >
                          خرید
                        </div>
                        <div
                          className={
                            active == "sell"
                              ? "tab-item tab-item-active w-100"
                              : "tab-item w-100"
                          }
                          onClick={() => {
                            document.getElementById("price_amount").value = "";
                            setGram("");
                            setSoat("");
                            setActive("sell");
                          }}
                        >
                          فروش
                        </div>
                      </div>
                    </div>
                  </div>

                  {active == "buy" ? (
                    <>
                      <div className="trade-item-container">
                        <div className="jusdyetfsxd65c5cccccc">
                          <div className="col-12">
                            <div className="w-100 pt-2 pb-2 pos-rel">
                              <input
                                type={"tel"}
                                name="price_amount"
                                id={"price_amount"}
                                className="form-input-gray-custom price-amount-pad"
                                onKeyUp={separateNum}
                                onChange={handleCalc}
                              />
                              <div className="label-trade-mablagh">مبلغ</div>
                            </div>
                            <div className="row">
                              {!selectedCommodity?.ui_data?.unit_name ? (
                                <div
                                  className={
                                    isTabletOrMobile ? "col-6" : "col-5"
                                  }
                                >
                                  <div className="w-100 pt-2 pb-2 pos-rel">
                                    <input
                                      type="number"
                                      name="soat"
                                      id={"soat"}
                                      className="form-input-gray-custom"
                                      value={
                                        (commodities || [])
                                          .find(
                                            (el) =>
                                              el.id == selectedCommodity.id
                                          )
                                          ?.name?.indexOf("طلا") >= 0
                                          ? soat !== 0
                                            ? soat
                                            : ""
                                          : ""
                                      }
                                      onChange={handleCalc}
                                    />
                                    <div className="label-trade-weight">
                                      {selectedCommodity?.ui_data?.unit_name ==
                                      null
                                        ? "سوت"
                                        : ""}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {!isTabletOrMobile && (
                                <div className="col-2">
                                  <div className="w-100 pt-2 pb-2 pos-rel text-center">
                                    <select
                                      name="commodity-type"
                                      id={"commodity-type"}
                                      className="form-input-gray-custom"
                                      value={selectedCommodity.id}
                                      onChange={(e) => {
                                        const selected = commodities.find(
                                          (el) => el.id == e.target.value
                                        );
                                        setSelectedCommodity(selected);
                                      }}
                                    >
                                      {commodities.map((item) => (
                                        <option value={item.id}>
                                          {item.name}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                              )}
                              <div
                                className={
                                  selectedCommodity.ui_data.unit_name != null
                                    ? isTabletOrMobile
                                      ? "col-12"
                                      : "col-10"
                                    : isTabletOrMobile
                                    ? "col-6"
                                    : "col-5"
                                }
                              >
                                <div className="w-100 pt-2 pb-2 pos-rel">
                                  <input
                                    type="number"
                                    name="gram"
                                    id={"gram"}
                                    className="form-input-gray-custom"
                                    value={gram !== 0 ? gram : ""}
                                    onChange={handleCalc}
                                  />
                                  <div className="label-trade-weight">
                                    {selectedCommodity.ui_data.unit_name !==
                                    null
                                      ? selectedCommodity.ui_data.unit_name
                                      : "گرم"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="w-100 pt-4 pb-2 jusdyetfsxd65c5cccccc">
                            {active == "buy" ? (
                              <button
                                className="form-input-button-custom"
                                type="button"
                                disabled={isLoading}
                                onClick={handleSubmit}
                              >
                                {isLoading ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست خرید</>
                                )}
                              </button>
                            ) : (
                              <button
                                className="btn btn-gold text-white btn-6464"
                                type="button"
                                disabled={isLoading}
                                onClick={handleSubmit}
                              >
                                {isLoading ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست فروش</>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="trade-item-container">
                        <div className="jusdyetfsxd65c5cccccc">
                          <div className="col-12">
                            <div className="w-100 pt-2 pb-2 pos-rel">
                              <input
                                type={"tel"}
                                name="price_amount"
                                id={"price_amount"}
                                className="form-input-gray-custom  price-amount-pad"
                                onKeyUp={separateNum}
                                onChange={handleCalc}
                              />
                              <div className="label-trade-mablagh">مبلغ</div>
                            </div>
                          </div>
                          <div className="row">
                            {selectedCommodity.ui_data.unit_name == null ? (
                              <div
                                className={isTabletOrMobile ? "col-6" : "col-5"}
                              >
                                <div className="w-100 pt-2 pb-2 pos-rel">
                                  <input
                                    type="number"
                                    name="soat"
                                    id={"soat"}
                                    className="form-input-gray-custom"
                                    value={
                                      (commodities || [])
                                        .find(
                                          (el) => el.id == selectedCommodity.id
                                        )
                                        ?.name?.indexOf("طلا") >= 0
                                        ? soat != 0
                                          ? soat
                                          : ""
                                        : ""
                                    }
                                    onChange={handleCalc}
                                  />
                                  <div className="label-trade-weight">سوت</div>
                                </div>
                              </div>
                            ) : (
                              <></>
                            )}
                            {!isTabletOrMobile && (
                              <div className="col-2">
                                <div className="w-100 pt-2 pb-2 pos-rel">
                                  <select
                                    name="commodity-type"
                                    id={"commodity-type"}
                                    className="form-input-gray-custom"
                                    value={selectedCommodity.id}
                                    onChange={(e) => {
                                      const selected = commodities.find(
                                        (el) => el.id == e.target.value
                                      );
                                      setSelectedCommodity(selected);
                                    }}
                                  >
                                    {commodities.map((item) => (
                                      <option value={item.id}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                              </div>
                            )}
                            <div
                              className={
                                selectedCommodity.ui_data.unit_name != null
                                  ? isTabletOrMobile
                                    ? "col-12"
                                    : "col-10"
                                  : isTabletOrMobile
                                  ? "col-6"
                                  : "col-5"
                              }
                            >
                              <div className="w-100 pt-2 pb-2 pos-rel">
                                <input
                                  type="number"
                                  name="gram"
                                  id={"gram"}
                                  className="form-input-gray-custom"
                                  value={gram != 0 ? gram : ""}
                                  onChange={handleCalc}
                                />
                                <div className="label-trade-weight">
                                  {selectedCommodity.ui_data.unit_name === null
                                    ? "گرم"
                                    : selectedCommodity.ui_data.unit_name}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="w-100 pt-4 pb-2 jusdyetfsxd65c5cccccc">
                            {active == "buy" ? (
                              <button
                                className="form-input-button-custom"
                                type="button"
                                disabled={isLoading}
                                onClick={handleSubmit}
                              >
                                {isLoading ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست خرید</>
                                )}
                              </button>
                            ) : (
                              <button
                                className="form-input-button-custom"
                                type="button"
                                disabled={isLoading}
                                onClick={handleSubmit}
                              >
                                {isLoading ? (
                                  <img
                                    src={"./loading.svg"}
                                    alt={""}
                                    className={"w-loading"}
                                  />
                                ) : (
                                  <>درخواست فروش</>
                                )}
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="margin-for-offer-lists lower-margin-for-offer-lists">
                <div className="scroll">
                  <div>
                    {isTabletOrMobile ? (
                      <ScrollOnMainPage key={`scroll-${render}`} />
                    ) : (
                      commodities.map(
                        (el) =>
                          el.id == selectedCommodity.id && (
                            <ScrollOnMainPage
                              key={`scroll-${render}`}
                              commodity={el}
                            />
                          )
                      )
                    )}
                  </div>
                </div>

                <Products />
              </div>
            </div>
          </>
        </MangeDashboard>
      </>
    </>
  );
}
